// Direct dans l'application : abonnement WebSocket à `directus_notifications` (les droits Directus limitent aux notifications du volontaire connecté).
// Reconnexion automatique avec attente croissante ; sans WebSocket, la page garde son comportement habituel (rechargement manuel).

export const useLiveNotifications = (onChange: () => void) => {
  const { token } = useDirectusToken()
  const baseUrl = String(useRuntimeConfig().public.directus.url || '').replace(/^http/, 'ws').replace(/\/$/, '')
  let socket: WebSocket | null = null
  let retry = 0
  let timer: ReturnType<typeof setTimeout> | undefined
  let stopped = false

  const connect = () => {
    if (stopped || !token.value || !baseUrl) return
    socket = new WebSocket(`${baseUrl}/websocket`)
    socket.onopen = () => socket?.send(JSON.stringify({ type: 'auth', access_token: token.value }))
    socket.onmessage = (message) => {
      let data: { type?: string, status?: string, event?: string }
      try {
        data = JSON.parse(String(message.data))
      }
      catch {
        return
      }
      if (data.type === 'ping') socket?.send(JSON.stringify({ type: 'pong' }))
      else if (data.type === 'auth' && data.status === 'ok') {
        retry = 0
        socket?.send(JSON.stringify({ type: 'subscribe', collection: 'directus_notifications', query: { fields: ['id'] } }))
      }
      else if (data.type === 'subscription' && data.event === 'create') onChange()
    }
    socket.onclose = () => {
      socket = null
      if (stopped) return
      retry = Math.min(retry + 1, 6)
      timer = setTimeout(connect, 1000 * 2 ** retry)
    }
    socket.onerror = () => socket?.close()
  }

  onMounted(connect)
  onBeforeUnmount(() => {
    stopped = true
    clearTimeout(timer)
    socket?.close()
  })
}
